import * as go from 'gojs/release/go-module';

export const rescaleDiagram = (diagram: go.Diagram) => {
  diagram.zoomToFit();
  diagram.alignDocument(go.Spot.Center, go.Spot.Center);
};
